export default {"src":"/_next/static/media/sx.96ff0bc2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};